import React, { CSSProperties } from "react";
import Title from "common/Typography/Title";
import {
  BotCardPropertyRow,
  BotCardSectionWrapper,
} from "features/bots/MyBots/common/styles";
import Flex from "common/Boxes/Flex";
import {
  BasicBotData,
  BotData,
  BotType,
  LanguageNameSpaces,
} from "@shared/types";
import {
  ENTRY_UUID,
  SIGNAL_ENTRY_UUID,
  SIGNAL_TAKE_PROFIT_UUID,
  TAKE_PROFIT_UUID,
} from "@shared/common/constants";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import TradingViewUUID from "features/bots/common/TradingViewUUID.tsx";
import { useSubUserPermissions } from "@shared/utils/hooks/misc.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface TradingViewUUIDsProps {
  botData: BasicBotData | BotData;
  isMobile?: boolean;
  style?: CSSProperties;
}

const TradingViewUUIDs = ({
  botData,
  isMobile,
  style,
}: TradingViewUUIDsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { entry_uuid, take_profit_uuid } = botData;
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { isReadOnly } = useSubUserPermissions();
  const isTradingViewSignalsBot =
    botData.bot_type === BotType.TRADING_VIEW_SIGNALS;

  if (isReadOnly) return null;

  const getUUIDRow = (title: string, uuid?: string) => {
    return (
      <BotCardPropertyRow $isMobile={isMobile} style={{ display: "flex" }}>
        <Title
          level={isBottomNavigator ? 5 : 4}
          type="secondary"
          style={{
            whiteSpace: "nowrap",
            marginRight: 20,
            width: isBottomNavigator ? 135 : 155,
            flex: "none",
          }}
        >
          {title}
        </Title>
        <Flex style={{ overflow: "hidden", justifyContent: "flex-end" }}>
          <TradingViewUUID name={title} uuid={uuid} />
        </Flex>
      </BotCardPropertyRow>
    );
  };

  return (
    <BotCardSectionWrapper $isMobile={isMobile} style={style}>
      {getUUIDRow(
        t(isTradingViewSignalsBot ? SIGNAL_ENTRY_UUID : ENTRY_UUID),
        entry_uuid
      )}
      {getUUIDRow(
        t(isTradingViewSignalsBot ? SIGNAL_TAKE_PROFIT_UUID : TAKE_PROFIT_UUID),
        take_profit_uuid
      )}
    </BotCardSectionWrapper>
  );
};

export default TradingViewUUIDs;
